import React, { Component } from 'react';
import { Input, Radio, Icon, Popover, DatePicker, InputNumber, Select, Checkbox } from 'antd';
import PatientCodeSearchInput from '../PatientCodeSearchInput';
import TemplateTree from './TemplateTree';
import moment from 'moment';

const TextArea = Input.TextArea;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { MonthPicker } = DatePicker;

class EditableCell extends Component {
	state = {
		value: this.props.cellValue ? this.props.cellValue.value : '',
		comment: (this.props.cellValue !== undefined && this.props.cellValue !== null) ? this.props.cellValue.comment : '',
		editable: false,
		text: this.props.cellValue || {},
		config: this.props.config
	}

	handleChange = (e) => {
		const value = e.target.value;
		this.setState({ value: value }, function () {
			this.props.onChange(this.state.value, "value");
		});
    }
    
	commentChange = (e) => {
		const value = e.target.value;
		this.setState({ comment: value });
		if (this.props.onChange) {
			this.props.onChange(value, "comment");
		}
	}

	clearValue = () => {
		this.setState({ value: '' });
		if (this.props.onChange) {
			this.props.onChange('', "value");
		}
	}

	handleBlur = (e) => {
		this.setState({
			editable: false,
			value: e.target.value
		});
	}

	handleValueBlur = (value) => {
		this.setState({
			editable: false,
			value: value
		});
	}

	check = () => {
		this.setState({ editable: false });
		if (this.props.onChange) {
			this.props.onChange(this.state.value, "value");
		}
    }
    
	edit = () => {
		this.setState({ editable: true });
    }

	onTextAreaChange = e => {
		const value = e.target.value;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
	}

	onRadioChange = (e) => {
		const value = e.target.value;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
	}

	onSelectChange = (value) => {
		this.setState({ value });
        if (this.props.onChange) {
            this.props.onChange(value, "value");
        }
	}

	onCheckBoxChange = array => {
		const value = array.join("//");
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
	}

	onControlBulr = array => {
		this.setState({ editable: false })
	}

	onNumberChange = (number) => {
		const value = number;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
		}
    }

	onDateChange = value => {
        let { config } = this.props;
        const { fieldWebType } = config;
        let format = '';
        if (fieldWebType == 'DATE_YEAR_MONTH_DAY') {
            format = 'YYYY-MM-DD';
        } else if (fieldWebType == 'DATE_YEAR_MONTH') {
            format = 'YYYY-MM';
        } else if (fieldWebType == 'DATE_YEAR_MONTH_DAY_HOUR_MINUTE') {
            format = 'YYYY-MM-DD HH:mm';
        }
		const valueString = moment(value).format(format);
		let valueFormat = valueString == "Invalid date" ? "" : valueString;
		this.setState({ value: valueFormat, editable: false });
		if (this.props.onChange) {
			this.props.onChange(valueFormat, "value");
		}
	}

	handleSelectPatient = object => {
		const value = object.patientCode;
		this.setState({ value: value });
		if (this.props.onChange) {
			this.props.onChange(value, "value");
			this.props.onPatientCodeChange(object, "value");
		}
	}

	showTemplateTree = () => {
        const { value, templateType = {} } = this.state;
        const { config } = this.props;
        const { followBoardDetailId } = config;
		if (value && value != Number(value)) {
			this.TemplateTreeRef.show(followBoardDetailId, value);
		} else {
			this.TemplateTreeRef.show(followBoardDetailId, templateType.optionName);
		}
	}
	
	saveTemplateData = params => {
		this.setState({
			editable: false,
			templateType: {...params},
			value: params.optionId || '',
		});
        const templateType = sessionStorage.templateType ?  JSON.parse(sessionStorage.templateType) : [];
        const isExist = templateType.some(item => {
            if (item[params.optionId]) {
                return params.optionName == item[params.optionId];
            }
        });
		!isExist && templateType.push({ [params.optionId]: params.optionName });
		sessionStorage.templateType = JSON.stringify(templateType);
		if (this.props.onChange) {
			this.props.onChange(params.optionId || '', "value");
		}
    }

    clearTemplateType = (e) => {
		e.stopPropagation();
		this.saveTemplateData({});
	}

	getRenderDom = (editable, comment) => {
		const { text, value, config } = this.state;
		let commentPop;
		let lockIcon = <Icon type="lock" className="un-editable" />;
		if (text.editable == 0 || this.props.isEdit == false) {
			config.isEdit = false;
		} else {
			config.isEdit = true;
		}
		if (text.color) {
			config.colorClass = text.color;
		} else {
			config.colorClass = "";
		}

		config.content = (
			<div>
				<Input type="textarea" rows={4} value={comment} disabled={!config.isEdit} onChange={this.commentChange} />
			</div>
		);
		if (config.comment.iscomment) {
			let popClass = comment == "" ? "pop nopop" : "pop";
			commentPop = <Popover className="popover-cell" content={config.content} title="备注" trigger="click"><i className={popClass}></i></Popover>;
		} else {
			commentPop = "";
		}
		const getRadioCell = () => {
			let optionValue = config.type.moduleDefineConstraintValue == undefined || config.type.moduleDefineConstraintValue == null ?
				null : config.type.moduleDefineConstraintValue.split("//");
			if (optionValue != null && config.isEdit) {
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
							editable ?
								<div>
									<RadioGroup value={value} onBulr={this.onControlBulr} options={optionValue} onChange={this.onRadioChange} />
									<Icon type="close-circle" onClick={this.clearValue} className="clear-icon" />
								</div>
								:
								<div>
									<p className="nowrap">{value || ' '}</p>
								</div>
                        }
                        {commentPop}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						{lockIcon}
                        {value || ' '}
                        {commentPop}
					</div>
				);
			}
		}

		const getCheckBoxCell = () => {
			let optionValue = config.type.moduleDefineConstraintValue == undefined || config.type.moduleDefineConstraintValue == null ?
				null : config.type.moduleDefineConstraintValue.split("//");
			const defaultValue = value == "" ? [] : value.split("//");
			if (optionValue != null && config.isEdit) {
				let checkboxShowVal = ''
				if (value) {
					checkboxShowVal = value.split("//").join(";");
				}
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
                            editable
                            ?
								<div>
									<CheckboxGroup options={optionValue} onBulr={this.onControlBulr} onChange={this.onCheckBoxChange} value={defaultValue} />
									<Icon type="close-circle" onClick={this.clearValue} className="clear-icon" />
								</div>
							:
								<div>
									<p className="nowrap">{checkboxShowVal}</p>
								</div>
                        }
                        {commentPop}
					</div>
				);
			} else {
				let checkboxShowVal = ''
				if (value) {
					checkboxShowVal = value.split("//").join(";");
				}
				return (
					<div className="editable-cell">
						{lockIcon}
						<p className="nowrap">{checkboxShowVal}</p>
                        {commentPop}
					</div>
				);
			}
		}

		const getSelectCell = () => {
			let optionValue = config.type.moduleDefineConstraintValue == undefined || config.type.moduleDefineConstraintValue == null ?
				null : config.type.moduleDefineConstraintValue.split("//");
			if (optionValue != null && config.isEdit) {
				const options = optionValue.map(d => <Option key={d} title={d}>{d}</Option>);
                return (
                    <div className="editable-cell" onClick={this.edit}>
                        {
                            editable
                            ?
                                <Select style={{ width: '100%' }} allowClear={true} onBlur={this.handleValueBlur} defaultValue={value} onChange={this.onSelectChange}>
                                    {options}
                                </Select>
                            :
                                <div>
                                    <p className="nowrap">{value || ' '}</p>
                                </div>
                        }
                        {commentPop}
                    </div>
                );
			} else {
				return (
					<div className="editable-cell">
						{lockIcon}
						<p className="nowrap">{value || ' '}</p>
                        {commentPop}
					</div>
				);
			}
		}

		const getInputCell = () => {
			if (config.isEdit) {
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
							editable ?
								<div className="editable-cell-input-wrapper">
									<Input value={value} onChange={this.handleChange} onBlur={this.handleBlur} onPressEnter={this.check} />
								</div>
								:
								<div>
									<p className="nowrap">{value || ' '}</p>
								</div>
						}
						{commentPop}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						<div>
							<p className="nowrap">{value || ' '}</p>
						</div>
						{lockIcon}
						{commentPop}
					</div>
				);
			}
		}

		const getTextAreaCell = () => {
			if (config.isEdit) {
                return (
                    <div className="editable-cell" onClick={this.edit}>
                        {
                            editable
                            ?
                                <TextArea style={{ width: '100%', resize: 'none' }} onBlur={this.handleBlur} autosize={{ minRows: 1, maxRows: 1 }} value={value} rows={1} onChange={this.onTextAreaChange} />
                            :
                                <div>
                                    <p className="nowrap">{value || ' '}</p>
                                </div>
                        }
                        {commentPop}
                    </div>
                );
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
                        {lockIcon}
                        {commentPop}
					</div>
				);
			}
		}

		const getDateCell = (formatValue) => {
			let showTime = null;
            if (formatValue == 'YYYY-MM-DD HH:mm') {
                showTime = { format: 'HH:mm' };
            }
			const defaultValue = value ? moment(value, formatValue) : null;
			let color = "";
			if (config.colorClass) {
				color = config.colorClass;
			}

			if (config.isEdit) {
				if (showTime) {
					return (
						<div className="editable-cell" onClick={this.edit}>
							{
								editable ?
									<div className="editable-cell-date-wrapper">
										<DatePicker style={{ width: '100%', color }} format={formatValue} onChange={this.onDateChange} value={defaultValue} showTime={showTime} placeholder="请选择时间" />
									</div>
									:
									<div className="editable-cell-date-wrapper" onClick={this.edit}>
										<p className="nowrap" style={{ color }}>{value || ' '}</p>
									</div>
							}
							{commentPop}
						</div>
					);
				} else {
                    return (
                        <div className="editable-cell" onClick={this.edit}>
                            {
                                editable ?
                                    <div className="editable-cell-date-wrapper">
                                        {
                                            formatValue == 'YYYY-MM-DD'
                                            ?
                                                <DatePicker style={{ width: '100%', color }} format={formatValue} onChange={this.onDateChange} value={defaultValue} />
                                            :
                                                <MonthPicker style={{ width: '100%', color }} format={formatValue} onChange={this.onDateChange} value={defaultValue} />
                                        }
                                    </div>
                                    :
                                    <div className="editable-cell-date-wrapper" onClick={this.edit}>
                                        <p className="nowrap" style={{ color }}>{value || ' '}</p>
                                    </div>
                            }
                            {commentPop}
                        </div>
                    )
				}
			} else {
				return (
					<div className="editable-cell">
						<p style={{ color: color }}>{value}</p>
						{lockIcon}
						{commentPop}
					</div>
				);
			}
		}

		const getNumberCell = () => {
			const limitDecimals = (value) => {
				const reg = /^(\-)*(\d+)\.(\d\d).*$/;
				if (typeof value === 'string') {
					return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
				} else if (typeof value === 'number') {
					return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
				} else {
					return ''
				}
			};
			if (config.isEdit) {
				return (
					<div className="editable-cell" onClick={this.edit}>
						{
							editable
							?
								<InputNumber
									value={value}
									style={{ width: '100%' }}
									onBlur={this.onControlBulr}
									onChange={this.onNumberChange}
									formatter={limitDecimals}
									parser={limitDecimals}
								/>
							:
								<div><p className="nowrap">{value || ' '}</p></div>
                        }
                        {commentPop}
					</div>
				);
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
                        {lockIcon}
                        {commentPop}
					</div>
				);
			}
		}

		const getPatientCodeSearchInput = () => {
			if (config.isEdit) {
				const initPatientCodeValue = { key: value, label: value };
				return (
                    <div className="editable-cell" onClick={this.edit}>
                        {
							editable
							?
                                <PatientCodeSearchInput
                                    defaultValue={value}
                                    style={{ width: '100%' }}
                                    handleSelectPatient={this.handleSelectPatient}
                                    initValue={initPatientCodeValue}
                                />
							:
								<div><p className="nowrap">{value || ' '}</p></div>
                        }
                        {commentPop}
                    </div>
				);
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
                        {lockIcon}
                        {commentPop}
					</div>
				);
			}
        }
        
        const getCascadeCell = () => {
            if (config.isEdit) {
				const { templateType = {}, value } = this.state;
                let optionName;
                if (value == Number(value)) {
                    const templateType = sessionStorage.templateType ?  JSON.parse(sessionStorage.templateType) : [];
                    templateType.map(item => {
                        if (item[value]) {
                            optionName = item[this.props.cellValue.value];
                        }
                    })
                }
                return (
                    <div className="editable-cell" onClick={this.edit}>
                        {
                            editable
                            ?
                                <div className="against-type">
                                    <Input defaultValue={value && (value == Number(value) ? templateType.optionName : value)} placeholder='请选择' onClick={this.showTemplateTree}/>
                                    {
                                        value &&
                                        <Icon
                                            className="close"
                                            type="close-circle"
                                            onClick={this.clearTemplateType}
                                        />
                                    }
                                </div>
                            :
                                <div>
                                    <p className="nowrap">{ templateType.optionName || (value && (value == Number(value) ? optionName : value)) || ''}</p>
                                </div>
                        }
                        {commentPop}
                    </div>
                );
			} else {
				return (
					<div className="editable-cell">
						<p className="nowrap">{value || ' '}</p>
                        {lockIcon}
                        {commentPop}
					</div>
				);
			}
        }

		switch (config.type.type) {
			case "TEXT":
				switch (config.type.webType) {
					case "RADIO":
						return getRadioCell();
					case "SELECT":
						return getSelectCell();
					case "CHECKBOX":
						return getCheckBoxCell();
					case "TEXTAREA":
                        return getTextAreaCell();
                    case "CASCADE_SELECT":
                        return getCascadeCell();
					default:
						return getInputCell();
				}
            case "DATE":
                switch (config.type.webType) {
                    case "DATE_YEAR_MONTH_DAY":
                        return getDateCell('YYYY-MM-DD');
                    case "DATE_YEAR_MONTH":
                        return getDateCell('YYYY-MM');
                    case "DATE_YEAR_MONTH_DAY_HOUR_MINUTE":
                        return getDateCell('YYYY-MM-DD HH:mm');
                }
                break;
			case "NUMBER":
				return getNumberCell();
			case "PatientCodeSearchSelect":
				return getPatientCodeSearchInput();
			default:
				return getInputCell();
		}
	}

	componentWillMount() {
		if (this.props.config.moduleDefineIsRequired == "1" && !this.props.cellValue) {
			this.setState({ editable: true });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.cellValue == undefined && this.state.value == '' && nextState.editable == this.state.editable && this.state.comment == nextState.comment) {
			return false;
		}
		if (nextProps.cellValue && nextProps.cellValue.value) {
			if ((nextProps.cellValue.value == (this.props.cellValue && this.props.cellValue.value)) && nextState.value == this.state.value && nextState.editable == this.state.editable
				&& (nextProps.cellValue.comment == (this.props.cellValue && this.props.cellValue.comment)) && this.state.comment == nextState.comment
			) {
				return false;
			}
		}
		return true;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.cellValue && (nextProps.cellValue.value || nextProps.cellValue.value == "")) {
			this.setState({
				value: nextProps.cellValue.value
			})
		}
		this.setState({
			config: nextProps.config
		})
	}

	render() {
		const { comment, editable } = this.state;
		return (
			<div>
				{this.getRenderDom(editable, comment)}
				<TemplateTree ref={el => this.TemplateTreeRef = el} saveTemplateData={this.saveTemplateData} isEnd={true} />
			</div>
		)
	}
}

export default EditableCell;


// WEBPACK FOOTER //
// ./src/components/execute/template/EditableCell.js